<template>
  <section class="flex flex-col items-center pr-12px md:pr-9">
    <p class="font-bold text-3xl" v-text="'Ingresa tus datos para continuar'" />
    <section class="w-full flex flex-col gap-y-4 pt-8">
      <input-field
        :rules="{
          required: true,
        }"
        v-model="name"
        :placeholder="'Nombre'"
        :isBig="false"
        ref="name"
        identity="Nombre"
      />
      <input-field
        :rules="{
          required: true,
        }"
        v-model="lastName"
        :placeholder="'Apellido'"
        :isBig="false"
        ref="lastName"
        identity="Apellido"
      />
      <input-field
        :rules="{
          required: true,
          email: true,
        }"
        v-model="email"
        :placeholder="'Email'"
        :isBig="false"
        ref="email"
        identity="Correo Electrónico"
      />
      <g-recaptcha
        :data-sitekey="sitekey"
        :data-callback="sendUserData"
        :data-validate="validateRecaptcha"
        data-language="es-419"
        data-size
        class="flex flex-col items-center"
      >
        <primary-button :disabled="isLoading" class="mt-8" :text="'Calcular'" />
      </g-recaptcha>
    </section>
  </section>
</template>
<script>
import axios from "axios";
import toastr from "toastr";
import gRecaptcha from "@finpo/vue2-recaptcha-invisible";

export default {
  mounted() {
    this.getIpAddress();
  },
  name: "ComponentModal",
  components: {
    InputField: () => import("./InputField.vue"),
    PrimaryButton: () => import("./PrimaryButton.vue"),
    gRecaptcha,
  },
  data: () => ({
    sitekey: process.env.VUE_APP_RECAPTCHA,
    name: null,
    lastName: null,
    phone: null,
    email: null,
    ip: null,
    town: null,
    country: null,
    genreOptions: [
      {
        id: 1,
        text: "Hombre",
      },
      {
        id: 2,
        text: "Mujer",
      },
    ],
    isLoading: false,
    isThereRequestError: false,
  }),
  props: {
    personData: {
      default: null,
    },
  },
  methods: {
    validateRecaptcha() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        return false;
      } else {
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
        toastr.error("Por favor, verifique que no es un robot");
        return true;
      }
    },
    validate() {
      const name = this.$refs.name.validate();
      const lastName = this.$refs.lastName.validate();
      const email = this.$refs.email.validate();
      return name || lastName || email;
    },
    async sendUserData(token) {
      if (this.validate() || this.callback(token) || this.isLoading) return;

      this.isLoading = true;

      const requestAuthorization = await axios.post("/oauth/token", {
        grant_type: "client_credentials",
        client_secret: process.env.VUE_APP_CLIENT_AP,
        client_id: process.env.VUE_APP_CLIENT_ID,
      });

      axios.defaults.headers.common["Authorization"] = `Bearer ${
        requestAuthorization.data.access_token
      }`;

      const requestDataPerson = await axios.post("/api/v1/contact-leads", {
        name: this.name,
        last_name: this.lastName,
        movil: null,
        landing_id: 1,
        ip: this.ip,
        town: this.town,
        country: this.country,
        proyect_id: process.env.VUE_APP_PROYECT_ID,
        email: this.email,
        data: this.personData,
      });

      if (requestDataPerson.data.success) {
        this.isThereRequestError = false;
        toastr.success(requestDataPerson.data.message);
        this.isLoading = false;
        this.$emit("close", true);
      } else {
        this.isThereRequestError = true;
        toastr.error(requestDataPerson.data.message);
        this.isLoading = false;
        this.$emit("close", false);
      }
    },
    async getIpAddress() {
      let url = "https://ipapi.co/json/";
      const response = await axios.get(url);
      this.ip = response.data.ip;
      this.town = response.data.city;
      this.country = response.data.country_name;
    },
  },
};
</script>
